export const updateArray = <T>(state: T[], item: T, key: keyof T): T[] => {
  const newState = [...state]

  const index = newState.findIndex(i => i[key] === item[key])

  if (index !== -1) {
    newState.splice(index, 1)
  } else {
    newState.push(item)
  }

  return newState
}

export function sortByKey(array, key) {
  return array.sort((a, b) => {
      if (a[key] < b[key]) {
          return -1;
      }
      if (a[key] > b[key]) {
          return 1;
      }
      return 0;
  });
}

export function getAllValues(obj) {
  let values = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        values = values.concat(getAllValues(obj[key]));
      } else {
        values.push(obj[key]);
      }
    }
  }
  return values;
}

export function getKeyValues(root) {
  const keyValues = []
  const visited = new Set()

  const targets = [root]
  while(targets.length) {
    const target = targets.shift()

    if (visited.has(target)) {
      continue // skip circular references
    }
    visited.add(target)

    const pairs = Object.entries(target)
    keyValues.push(...pairs) // current key-value pairs

    for (const [key, value] of pairs) {
      if (value && typeof value === 'object') {
        targets.push(value) // include nested
      }
    }
  }

  return keyValues
}

type PickValues<T, K extends keyof T> = { [P in K]: T[P] }[K];

export function getValuesByKeys<T extends object, K extends keyof T>(obj: T, keys: K[]): PickValues<T, K>[] {
  return keys.map(key => obj[key]);
}

/** Loose record shape these helpers sort/pluck over. Referenced by `multiSort`
 *  since it was written, but never actually declared. */
type MyObject = Record<string, any>;

export function multiSort(arr: MyObject[], sortOrders: { [key: string]: 'asc' | 'desc' }): MyObject[] {
  return arr.sort((a, b) => {
    for (const key in sortOrders) {
      const order = sortOrders[key];
      let comparison = 0;

      // check nested keys
      const pathArray = key.split(".");
      let aKey = a;
      for (const part of pathArray) {
        aKey = aKey[part];
      }
      let bKey = b 
      for (const part of pathArray) {
        bKey = bKey[part];
      }
      
      if (aKey < bKey) {
        comparison = -1;
      } else if (aKey > bKey) {
        comparison = 1;
      }

      if (comparison !== 0) {
        return order === 'asc' ? comparison : -comparison;
      }
    }
    return 0; // Return 0 if all properties are equal
  });
}